import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteTeam = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id }: { id: number }) => {
    return axios.delete(`${env.verifyServiceUrl}common/team/${id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
